import React, { useEffect, useState } from 'react';
import DataTableComponent from '../../commonComponents/DataTableComponent';
import CollapseComponent from '../../commonComponents/CollapseComponent';
import { HoverBtnComponent } from '../../../components/commonComponents/UIComponent';

const StepThreeTable = ({ previewData, filterButton, formData }) => {

    const [cardBody, setcardBody] = useState(null);

    useEffect(() => {
        setTimeout(() => {
            feather.replace();
        }, 2);

        if (Object.keys(previewData).length > 0) {
            let tableNames = [];
            let sampleBody = null;
            let columnData = {};

            tableNames = Object.keys(previewData);

            tableNames.map(individualName => {

                previewData[individualName].columnArray.map(function (el) {
                    if (columnData[individualName]) {
                        columnData[individualName].push({ "virtualName": el.raw_column_name, "rawField": el.raw_column_name, sortable: false })
                    } else {
                        columnData[individualName] = [{ "virtualName": el.raw_column_name, "rawField": el.raw_column_name, sortable: false }]
                    }
                });
            })

            sampleBody = tableNames.map(individualName => {
                let tempId = individualName.replace(".", "_");
                let collapseBody = <DataTableComponent
                    tableData={previewData[individualName]['sampleData']}
                    columnData={columnData[individualName]}
                />
                let collapseHead = <>
                    <span>
                        {individualName} (Total Records: {previewData[individualName]["totalRecords"]})
                    </span>
                    {/* Commented old code of preview button */}
                    {/* <span data-toggle="collapse" href={`#collapseExample_${tempId}`} aria-expanded="false" aria-controls="collapseExample">
                        <span className="ui-accordion-header-icon ui-icon ui-icon-triangle-1-s"></span>{individualName} (Total Records: {previewData[individualName]["totalRecords"]})
                    </span> */}
                    <HoverBtnComponent
                        btnData={
                            {
                                "className": "float-right",
                                icon: true,
                                iconName: formData[individualName].validation === true ? {status: 'text-success', icon: 'check-circle'} : {status: 'text-danger', icon: 'x-circle'},
                                style: { lineHeight: "1.5" },
                                eventFunction: filterButton,
                                btnName: "Apply Filter",
                                eventType: "filter",
                                btnKey: `hoverBtn${tempId}${Math.floor(Math.random() * 10)}`
                            }
                        }
                        eventParams={{ tableName: individualName }} />
                </>
                return (
                    <CollapseComponent collapseBody={collapseBody} collapseName={individualName} indexName={tempId} collapseHead={collapseHead} />
                )
            });
            setcardBody(sampleBody);
        }
    }, [previewData, formData])

    return (cardBody)
}
export default StepThreeTable;
